import { Flex, Text, History } from '@amzn/ring-ui-react-components';
import { useIsMobile } from 'src/shared/hooks';

interface Props {
  limit: number;
}

export const NoMediaSelected = (props: Props) => {
  const { limit } = props;
  const isMobile = useIsMobile();
  const direction = isMobile ? 'below' : 'on the left';
  const hint = `Choose up to ${limit} files from the list ${direction}`;
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      mt={isMobile ? 0 : 200}
      mb={isMobile ? 10 : 0}
    >
      <History boxSize={10} mb="13px" color="primary.500" />

      <Text fontSize="lg" align="center" mb="16px" fontWeight="semibold">
        Select media from your Ring Library
      </Text>
      <Text fontSize="xs" align="center">
        {hint}
      </Text>
    </Flex>
  );
};

export default NoMediaSelected;
